import { createApp } from 'vue';
import FreeAppView from '../../free/FreeAppView.vue'
const appElements = document.querySelectorAll('.vue-basic-app-view')

Array.from(appElements).forEach(element => {
  createApp(FreeAppView).mount(element);
});